export const tooltips = {
	order: ['title', 'description', 'addStep'],
	currentTip: 0,
	title: {
		content: `
			<h5>Start with a good title</h5>
			<p>The title should be useful, but keep it short and easy to read.</p>
		`,
		active: true
	},
	description: {
		content: `
			<h5>Make it easy to find</h5>
			<p>Use this form to describe what your tutorial is about so other engineers can find it</p>
		`,
		active: false
	},
	addStep: {
		content: `
			<h5>Create steps for your tutorial</h5>
			<p>You can embed videos and photos into any of the steps. The image from your final step will show up as your tutorial thumbnail in the library.</p>
		`,
		active: false
	},
	skillLevel: {
		content: `
			<h5>Skill level helps users find more suitable tutorials.</h5>
			<p>Select <strong>Beginner</strong> when anyone could follow your tutorial,
				<strong>Intermediate</strong> when some knowledge is required.
				<strong>Advanced</strong> tutorials are for pros.
			</p>
		`
	},
	stepErrors: {
		intro: {
			content: `
				<strong>Fill in details</strong>
			`,
			placement: 'left',
			classes: ['tooltip--error'],
			boundariesElement: 'body'
		}
	}
}
